/* istanbul ignore file */
import { parsers } from '@codegrade/utils';
import { AccessTokenModalWarningTimeSetting } from './AccessTokenModalWarningTimeSetting';
import { AccessTokenToastWarningTimeSetting } from './AccessTokenToastWarningTimeSetting';
import { AssignmentDefaultGradingScalePointsSetting } from './AssignmentDefaultGradingScalePointsSetting';
import { AssignmentDefaultGradingScaleSetting } from './AssignmentDefaultGradingScaleSetting';
import { AssignmentMaxPointsEnabledSetting } from './AssignmentMaxPointsEnabledSetting';
import { AssignmentPercentageDecimalsSetting } from './AssignmentPercentageDecimalsSetting';
import { AssignmentPointDecimalsSetting } from './AssignmentPointDecimalsSetting';
import { AssistantModelsSetting } from './AssistantModelsSetting';
import { BlackboardZipUploadEnabledSetting } from './BlackboardZipUploadEnabledSetting';
import { CodeEditorStartOnAssignmentDescriptionSetting } from './CodeEditorStartOnAssignmentDescriptionSetting';
import { DefaultCourseTaRoleSetting } from './DefaultCourseTaRoleSetting';
import { DefaultCourseTeacherRoleSetting } from './DefaultCourseTeacherRoleSetting';
import { DefaultCourseTierSetting } from './DefaultCourseTierSetting';
import { DefaultSubmissionPageTabSetting } from './DefaultSubmissionPageTabSetting';
import { DownloadEditorFilesEnabledSetting } from './DownloadEditorFilesEnabledSetting';
import { ExamHeartbeatSetting } from './ExamHeartbeatSetting';
import { GradingNotificationsEnabledSetting } from './GradingNotificationsEnabledSetting';
import { HideCodeEditorFiletreeControlsWithOnlyQuizStepsSetting } from './HideCodeEditorFiletreeControlsWithOnlyQuizStepsSetting';
import { HideCodeEditorOutputViewerWithOnlyQuizStepsSetting } from './HideCodeEditorOutputViewerWithOnlyQuizStepsSetting';
import { HideNoDeadlineEnabledSetting } from './HideNoDeadlineEnabledSetting';
import { HubspotSyncingEnabledSetting } from './HubspotSyncingEnabledSetting';
import { InlineRubricViewerEnabledSetting } from './InlineRubricViewerEnabledSetting';
import { IsPearsonSetting } from './IsPearsonSetting';
import { JwtAccessTokenExpiresSetting } from './JwtAccessTokenExpiresSetting';
import { LoginTokenBeforeTimeSetting } from './LoginTokenBeforeTimeSetting';
import { Lti1p3NonceAndStateValidationEnabledSetting } from './Lti1p3NonceAndStateValidationEnabledSetting';
import { Lti1p3SystemRoleFromContextRoleSetting } from './Lti1p3SystemRoleFromContextRoleSetting';
import { LtiLaunchDataLoggingSetting } from './LtiLaunchDataLoggingSetting';
import { LtiLockDateCopyingEnabledSetting } from './LtiLockDateCopyingEnabledSetting';
import { LtiRoleSwitchingSetting } from './LtiRoleSwitchingSetting';
import { MaxFileSizeSetting } from './MaxFileSizeSetting';
import { MaxLargeUploadSizeSetting } from './MaxLargeUploadSizeSetting';
import { MaxNormalUploadSizeSetting } from './MaxNormalUploadSizeSetting';
import { MinPasswordScoreSetting } from './MinPasswordScoreSetting';
import { NameAndEmailFromNrpsOnlySetting } from './NameAndEmailFromNrpsOnlySetting';
import { NewAutoTestDefaultOsSetting } from './NewAutoTestDefaultOsSetting';
import { NewAutoTestUbuntu2004BaseImageIdsSetting } from './NewAutoTestUbuntu2004BaseImageIdsSetting';
import { NewAutoTestUbuntu2404BaseImageIdsSetting } from './NewAutoTestUbuntu2404BaseImageIdsSetting';
import { PaymentsProviderSetting } from './PaymentsProviderSetting';
import { PerCoursePaymentAllowedSetting } from './PerCoursePaymentAllowedSetting';
import { PowDifficultySetting } from './PowDifficultySetting';
import { QuizMinimumQuestionsForDropdownSetting } from './QuizMinimumQuestionsForDropdownSetting';
import { RegisterEnabledSetting } from './RegisterEnabledSetting';
import { SendRegistrationEmailSetting } from './SendRegistrationEmailSetting';
import { ShowPremiumBadgesSetting } from './ShowPremiumBadgesSetting';
import { SimpleSubmissionNavigateToLatestEditorSessionSetting } from './SimpleSubmissionNavigateToLatestEditorSessionSetting';
import { SsoUsernameDecollisionEnabledSetting } from './SsoUsernameDecollisionEnabledSetting';
import { StudentPaymentMainOptionSetting } from './StudentPaymentMainOptionSetting';
import { TierAdvancedAiEnabledSetting } from './TierAdvancedAiEnabledSetting';
import { TierAdvancedAtv1EnabledSetting } from './TierAdvancedAtv1EnabledSetting';
import { TierAdvancedExtendedRuntimeEnabledSetting } from './TierAdvancedExtendedRuntimeEnabledSetting';
import { TierAdvancedJupyterEnabledSetting } from './TierAdvancedJupyterEnabledSetting';
import { TierAdvancedLtiEnabledSetting } from './TierAdvancedLtiEnabledSetting';
import { TierAdvancedMaxStaffSetting } from './TierAdvancedMaxStaffSetting';
import { TierAdvancedMaxStudentsSetting } from './TierAdvancedMaxStudentsSetting';
import { TierAdvancedQuizEnabledSetting } from './TierAdvancedQuizEnabledSetting';
import { TierAdvancedUnlimitedInstallStepsEnabledSetting } from './TierAdvancedUnlimitedInstallStepsEnabledSetting';
import { TierFreeAiEnabledSetting } from './TierFreeAiEnabledSetting';
import { TierFreeAtv1EnabledSetting } from './TierFreeAtv1EnabledSetting';
import { TierFreeExtendedRuntimeEnabledSetting } from './TierFreeExtendedRuntimeEnabledSetting';
import { TierFreeJupyterEnabledSetting } from './TierFreeJupyterEnabledSetting';
import { TierFreeLtiEnabledSetting } from './TierFreeLtiEnabledSetting';
import { TierFreeMaxStaffSetting } from './TierFreeMaxStaffSetting';
import { TierFreeMaxStudentsSetting } from './TierFreeMaxStudentsSetting';
import { TierFreeQuizEnabledSetting } from './TierFreeQuizEnabledSetting';
import { TierFreeUnlimitedInstallStepsEnabledSetting } from './TierFreeUnlimitedInstallStepsEnabledSetting';
import { TierStarterAiEnabledSetting } from './TierStarterAiEnabledSetting';
import { TierStarterAtv1EnabledSetting } from './TierStarterAtv1EnabledSetting';
import { TierStarterExtendedRuntimeEnabledSetting } from './TierStarterExtendedRuntimeEnabledSetting';
import { TierStarterJupyterEnabledSetting } from './TierStarterJupyterEnabledSetting';
import { TierStarterLtiEnabledSetting } from './TierStarterLtiEnabledSetting';
import { TierStarterMaxStaffSetting } from './TierStarterMaxStaffSetting';
import { TierStarterMaxStudentsSetting } from './TierStarterMaxStudentsSetting';
import { TierStarterQuizEnabledSetting } from './TierStarterQuizEnabledSetting';
import { TierStarterUnlimitedInstallStepsEnabledSetting } from './TierStarterUnlimitedInstallStepsEnabledSetting';
const SiteSettingInputParser = 
/* #__PURE__ */ /* #__PURE__ */ parsers.lazy(() => 
/* #__PURE__ */ parsers.taggedUnion('name', [
    ['ASSIGNMENT_MAX_POINTS_ENABLED', AssignmentMaxPointsEnabledSetting],
    ['DOWNLOAD_EDITOR_FILES_ENABLED', DownloadEditorFilesEnabledSetting],
    ['GRADING_NOTIFICATIONS_ENABLED', GradingNotificationsEnabledSetting],
    ['HIDE_NO_DEADLINE_ENABLED', HideNoDeadlineEnabledSetting],
    ['SHOW_PREMIUM_BADGES', ShowPremiumBadgesSetting],
    ['INLINE_RUBRIC_VIEWER_ENABLED', InlineRubricViewerEnabledSetting],
    ['REGISTER_ENABLED', RegisterEnabledSetting],
    ['MAX_FILE_SIZE', MaxFileSizeSetting],
    ['MAX_LARGE_UPLOAD_SIZE', MaxLargeUploadSizeSetting],
    ['MAX_NORMAL_UPLOAD_SIZE', MaxNormalUploadSizeSetting],
    ['ASSIGNMENT_DEFAULT_GRADING_SCALE', AssignmentDefaultGradingScaleSetting],
    ['ASSIGNMENT_DEFAULT_GRADING_SCALE_POINTS', AssignmentDefaultGradingScalePointsSetting],
    ['ASSIGNMENT_PERCENTAGE_DECIMALS', AssignmentPercentageDecimalsSetting],
    ['ASSIGNMENT_POINT_DECIMALS', AssignmentPointDecimalsSetting],
    ['ASSISTANT_MODELS', AssistantModelsSetting],
    [
        'CODE_EDITOR_START_ON_ASSIGNMENT_DESCRIPTION',
        CodeEditorStartOnAssignmentDescriptionSetting,
    ],
    ['DEFAULT_COURSE_TA_ROLE', DefaultCourseTaRoleSetting],
    ['DEFAULT_COURSE_TEACHER_ROLE', DefaultCourseTeacherRoleSetting],
    ['DEFAULT_COURSE_TIER', DefaultCourseTierSetting],
    ['DEFAULT_SUBMISSION_PAGE_TAB', DefaultSubmissionPageTabSetting],
    [
        'HIDE_CODE_EDITOR_OUTPUT_VIEWER_WITH_ONLY_QUIZ_STEPS',
        HideCodeEditorOutputViewerWithOnlyQuizStepsSetting,
    ],
    [
        'HIDE_CODE_EDITOR_FILETREE_CONTROLS_WITH_ONLY_QUIZ_STEPS',
        HideCodeEditorFiletreeControlsWithOnlyQuizStepsSetting,
    ],
    ['NEW_AUTO_TEST_DEFAULT_OS', NewAutoTestDefaultOsSetting],
    ['NEW_AUTO_TEST_UBUNTU_20_04_BASE_IMAGE_IDS', NewAutoTestUbuntu2004BaseImageIdsSetting],
    ['NEW_AUTO_TEST_UBUNTU_24_04_BASE_IMAGE_IDS', NewAutoTestUbuntu2404BaseImageIdsSetting],
    ['QUIZ_MINIMUM_QUESTIONS_FOR_DROPDOWN', QuizMinimumQuestionsForDropdownSetting],
    ['SEND_REGISTRATION_EMAIL', SendRegistrationEmailSetting],
    [
        'SIMPLE_SUBMISSION_NAVIGATE_TO_LATEST_EDITOR_SESSION',
        SimpleSubmissionNavigateToLatestEditorSessionSetting,
    ],
    ['ACCESS_TOKEN_MODAL_WARNING_TIME', AccessTokenModalWarningTimeSetting],
    ['ACCESS_TOKEN_TOAST_WARNING_TIME', AccessTokenToastWarningTimeSetting],
    ['JWT_ACCESS_TOKEN_EXPIRES', JwtAccessTokenExpiresSetting],
    ['LOGIN_TOKEN_BEFORE_TIME', LoginTokenBeforeTimeSetting],
    ['MIN_PASSWORD_SCORE', MinPasswordScoreSetting],
    ['POW_DIFFICULTY', PowDifficultySetting],
    ['PAYMENTS_PROVIDER', PaymentsProviderSetting],
    ['PER_COURSE_PAYMENT_ALLOWED', PerCoursePaymentAllowedSetting],
    ['STUDENT_PAYMENT_MAIN_OPTION', StudentPaymentMainOptionSetting],
    ['HUBSPOT_SYNCING_ENABLED', HubspotSyncingEnabledSetting],
    [
        'LTI_1P3_NONCE_AND_STATE_VALIDATION_ENABLED',
        Lti1p3NonceAndStateValidationEnabledSetting,
    ],
    ['LTI_1P3_SYSTEM_ROLE_FROM_CONTEXT_ROLE', Lti1p3SystemRoleFromContextRoleSetting],
    ['LTI_LAUNCH_DATA_LOGGING', LtiLaunchDataLoggingSetting],
    ['LTI_LOCK_DATE_COPYING_ENABLED', LtiLockDateCopyingEnabledSetting],
    ['LTI_ROLE_SWITCHING', LtiRoleSwitchingSetting],
    ['NAME_AND_EMAIL_FROM_NRPS_ONLY', NameAndEmailFromNrpsOnlySetting],
    ['SSO_USERNAME_DECOLLISION_ENABLED', SsoUsernameDecollisionEnabledSetting],
    ['BLACKBOARD_ZIP_UPLOAD_ENABLED', BlackboardZipUploadEnabledSetting],
    ['IS_PEARSON', IsPearsonSetting],
    ['EXAM_HEARTBEAT', ExamHeartbeatSetting],
    ['TIER_FREE_AI_ENABLED', TierFreeAiEnabledSetting],
    ['TIER_FREE_LTI_ENABLED', TierFreeLtiEnabledSetting],
    ['TIER_FREE_ATV1_ENABLED', TierFreeAtv1EnabledSetting],
    ['TIER_FREE_JUPYTER_ENABLED', TierFreeJupyterEnabledSetting],
    ['TIER_FREE_QUIZ_ENABLED', TierFreeQuizEnabledSetting],
    ['TIER_FREE_EXTENDED_RUNTIME_ENABLED', TierFreeExtendedRuntimeEnabledSetting],
    [
        'TIER_FREE_UNLIMITED_INSTALL_STEPS_ENABLED',
        TierFreeUnlimitedInstallStepsEnabledSetting,
    ],
    ['TIER_FREE_MAX_STUDENTS', TierFreeMaxStudentsSetting],
    ['TIER_FREE_MAX_STAFF', TierFreeMaxStaffSetting],
    ['TIER_STARTER_AI_ENABLED', TierStarterAiEnabledSetting],
    ['TIER_STARTER_LTI_ENABLED', TierStarterLtiEnabledSetting],
    ['TIER_STARTER_ATV1_ENABLED', TierStarterAtv1EnabledSetting],
    ['TIER_STARTER_JUPYTER_ENABLED', TierStarterJupyterEnabledSetting],
    ['TIER_STARTER_QUIZ_ENABLED', TierStarterQuizEnabledSetting],
    ['TIER_STARTER_EXTENDED_RUNTIME_ENABLED', TierStarterExtendedRuntimeEnabledSetting],
    [
        'TIER_STARTER_UNLIMITED_INSTALL_STEPS_ENABLED',
        TierStarterUnlimitedInstallStepsEnabledSetting,
    ],
    ['TIER_STARTER_MAX_STUDENTS', TierStarterMaxStudentsSetting],
    ['TIER_STARTER_MAX_STAFF', TierStarterMaxStaffSetting],
    ['TIER_ADVANCED_AI_ENABLED', TierAdvancedAiEnabledSetting],
    ['TIER_ADVANCED_LTI_ENABLED', TierAdvancedLtiEnabledSetting],
    ['TIER_ADVANCED_ATV1_ENABLED', TierAdvancedAtv1EnabledSetting],
    ['TIER_ADVANCED_JUPYTER_ENABLED', TierAdvancedJupyterEnabledSetting],
    ['TIER_ADVANCED_QUIZ_ENABLED', TierAdvancedQuizEnabledSetting],
    ['TIER_ADVANCED_EXTENDED_RUNTIME_ENABLED', TierAdvancedExtendedRuntimeEnabledSetting],
    [
        'TIER_ADVANCED_UNLIMITED_INSTALL_STEPS_ENABLED',
        TierAdvancedUnlimitedInstallStepsEnabledSetting,
    ],
    ['TIER_ADVANCED_MAX_STUDENTS', TierAdvancedMaxStudentsSetting],
    ['TIER_ADVANCED_MAX_STAFF', TierAdvancedMaxStaffSetting],
]));
export const SiteSettingInput = SiteSettingInputParser;
